namespace $.$$ {
	
	$mol_style_define( $shm_period, {
		
		align: {
			items: 'center',
		},
		flex: {
			wrap: 'wrap',
		},
		
	} )
	
}
